import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { sendSentryClientErrorOnce } from 'shared/lib/sendSentryClientError';

import type { TAnalyticsState } from '../types';

const initialState: TAnalyticsState = {
  base: null,
};

const DEFAULT_ANALYTICS_BASE = {
  utm: {},
  partner: {},
  clid: undefined,
  deviceUUID: undefined,
  promotionQuery: {},
};

export const analyticsSlice = createSlice({
  initialState,
  name: 'analytics',
  reducers: {
    setAnalyticsBase: (state, { payload }: PayloadAction<TAnalyticsState['base']>) => {
      state.base = payload;
    },
    setAffSub5: (state, { payload }: PayloadAction<string>) => {
      // если нет данных в сторе, создаем дефолтный
      if (!state.base) {
        sendSentryClientErrorOnce(true, 'Нет данных в analytics store', {
          level: 'log',
        });

        state.base = { ...DEFAULT_ANALYTICS_BASE };
      }

      state.base.partner.affSub5 = payload;
    },
    setAffSub3: (state, { payload }: PayloadAction<string>) => {
      // если нет данных в сторе, создаем дефолтный
      if (!state.base) {
        sendSentryClientErrorOnce(true, 'Нет данных в analytics store', {
          level: 'log',
        });

        state.base = { ...DEFAULT_ANALYTICS_BASE };
      }

      state.base.partner.affSub3 = payload;
    },
    updateAnalyticsIds: (
      state,
      {
        payload,
      }: PayloadAction<{
        uaClientId: NonNullable<TAnalyticsState['base']>['utm']['uaClientId'];
        ymClientId: NonNullable<TAnalyticsState['base']>['utm']['ymClientId'];
      }>,
    ) => {
      if (!state.base?.utm) {
        state.base = { ...DEFAULT_ANALYTICS_BASE };
      }

      state.base.utm.uaClientId = payload.uaClientId;
      state.base.utm.ymClientId = payload.ymClientId;
    },
  },
});

export const { setAnalyticsBase, setAffSub5, setAffSub3, updateAnalyticsIds } = analyticsSlice.actions;
